const isObject = (elem) => typeof elem === 'object' && elem !== null

export default isObject